import React from 'react';
import './Offers.css';

import { Button, Heading } from '../../../components';
import { offers } from '../../../constants';



const Offers = () => {
  return (
    <section className="offers">

        {/* Section Heading */}
        <Heading title={'Latest Offers'} subTitle={'Our Deals'} />

        <div className="box-container">
            {offers.map((offer) => (
            <div key={offer.id} className={`offer-item offer-${offer.id}`}>

                <img src={offer.image} alt={offer.title} /> {/* Offer Image */}
                <div className="content">
                  <p>{offer.description}</p> {/* Offer Description */}
                  <h3>{offer.title}</h3> {/* Offer Title */}
                  <Button link={offer.link} title={'Shop Now'} /> {/* Shop Now Button */}
                </div>

            </div>
            ))}
        </div>

    </section>
  );
};

export default Offers;